/* Only real, explicitly approved Shopify allocations may enable deposit checkout. */
function pfBackorderState(variant, config) {
  if (!variant || !variant.backorder) return { active: false, ready: false };
  const allowed = config.planIds.split(',').map(id => id.trim()).filter(Boolean);
  const plan = variant.plans.find(p => allowed.includes(String(p.id)) && p.recurring === false &&
    p.chargeType === 'percentage' && Number(p.chargeValue) === 30 &&
    Number.isFinite(p.total) && p.total > 0 && Number.isFinite(p.deposit) && Number.isFinite(p.balance) &&
    Math.abs(p.deposit - Math.round(p.total * .3)) <= 1 && p.deposit + p.balance === p.total);
  return { active: true, ready: config.mode === 'connected' && config.shippingReady && variant.available && !!plan, plan };
}
if (typeof module !== 'undefined') module.exports = { pfBackorderState };
if (typeof customElements !== 'undefined' && !customElements.get('pf-backorder')) {
  customElements.define('pf-backorder', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      if (!this.form) return;
      this.scope = this.closest('[id^="PFProduct-"]') || this.closest('.shopify-section') || this.form;
      this.variants = JSON.parse(this.querySelector('[data-bo-variants]').textContent);
      this.config = { mode: this.dataset.mode, shippingReady: this.dataset.shippingReady === 'true', planIds: this.dataset.planIds || '' };
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.form.addEventListener('change', () => this.update(), options);
      this.form.addEventListener('input', () => this.update(), options);
      this.scope.addEventListener('pf:variant-change', () => this.update(), options);
      this.form.addEventListener('submit', event => {
        this.update();
        if (this.state.active && !this.state.ready) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, { ...options, capture: true });
      this.observer = new MutationObserver(() => this.update());
      const idInput = this.form.querySelector('[name="id"]');
      if (idInput) this.observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
    update() {
      const variant = this.variants[this.form.querySelector('[name="id"]')?.value];
      const previous = this.state?.active;
      this.state = pfBackorderState(variant, this.config);
      this.hidden = !this.state.active;
      const input = this.querySelector('[data-bo-plan]');
      input.disabled = !this.state.ready;
      input.value = this.state.ready ? this.state.plan.id : '';
      const idInput = this.form.querySelector('[name="id"]');
      if (this.state.active) idInput.disabled = !this.state.ready;
      else if (previous) idInput.disabled = !variant?.available;
      const warranty = this.scope.querySelector('[data-warranty-addon-variant-id]');
      if (warranty) {
        if (this.state.active && !warranty.dataset.boManaged) {
          warranty.dataset.boManaged = 'true'; warranty.dataset.boWasDisabled = String(warranty.disabled);
          warranty.checked = false; warranty.disabled = true;
        } else if (!this.state.active && warranty.dataset.boManaged) {
          warranty.disabled = warranty.dataset.boWasDisabled === 'true'; delete warranty.dataset.boManaged;
        }
      }
      this.form.querySelectorAll('.shopify-payment-button').forEach(el => { el.hidden = this.state.active; });
      const buttons = [...this.form.querySelectorAll('[name="add"]'), ...this.scope.querySelectorAll('[data-sticky-add]')];
      if (!this.state.active) {
        if (previous) buttons.forEach(button => {
          button.disabled = !variant?.available;
          const label = button.querySelector('[data-add-button-text], span') || button;
          label.textContent = variant?.available ? 'Add to cart' : 'Sold out';
        });
        return;
      }
      const quantity = Math.max(1, parseInt(this.form.querySelector('[name="quantity"]')?.value || '1', 10) || 1);
      const total = this.state.plan?.total ?? variant.price;
      const deposit = this.state.plan?.deposit ?? Math.round(total * .3);
      const balance = this.state.plan?.balance ?? total - deposit;
      const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:this.dataset.currency,currencyDisplay:'code'}).format(amount * quantity / 100);
      this.querySelector('[data-bo-total]').textContent = money(total);
      this.querySelector('[data-bo-deposit]').textContent = money(deposit);
      this.querySelector('[data-bo-balance]').textContent = money(balance);
      this.querySelector('[data-bo-status]').hidden = this.state.ready || this.config.mode === 'preview';
      this.querySelector('[data-bo-status]').textContent = this.config.mode === 'preview' ? '' : 'Backorders are temporarily unavailable for this option.';
      buttons.forEach(button => {
        button.disabled = !this.state.ready;
        const label = button.querySelector('[data-add-button-text], span') || button;
        label.textContent = `Back order — ${money(deposit)} deposit`;
      });
    }
  });
}
